import { forwardRef } from 'react';

import { IconProps } from '../';

export const TimelineTriangleIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size = 20, ...props }, ref) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" ref={ref} {...props} {...{ className }}>
      <g filter="url(#filter0_d_4003_40697)">
        <path
          d="M9.13398 4.5C9.51888 3.83333 10.4811 3.83333 10.866 4.5L15.6292 12.75C16.0141 13.4167 15.5329 14.25 14.7631 14.25H5.23686C4.46706 14.25 3.98593 13.4167 4.37083 12.75L9.13398 4.5Z"
          fill="#F99226"
        />
        <path
          d="M8.26758 4C9.03738 2.66666 10.9626 2.66667 11.7324 4L16.4951 12.25C17.2649 13.5833 16.3023 15.25 14.7627 15.25H5.2373C3.6977 15.25 2.73508 13.5833 3.50488 12.25L8.26758 4Z"
          fill="none"
          stroke="white"
          strokeWidth="2"
        />
      </g>
      <defs>
        <filter id="filter0_d_4003_40697" x="0.232391" y="1" width="19.5352" height="18.25" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4003_40697" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4003_40697" result="shape" />
        </filter>
      </defs>
    </svg>
  );
});

export default TimelineTriangleIcon;
